import React from 'react';
import { Typography } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import BaseModal from './BaseModal';

interface ConfirmationModalProps {
  open: boolean;
  title: string;
  subtitle?: string;
  message: string | React.ReactNode;
  children?: React.ReactNode;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel: () => void;
  severity?: 'warning' | 'error' | 'info';
  submitDisabled?: boolean;
  submitLoading?: boolean;
  dataTestId?: string;
  maxWidth?: 'xs' | 'sm' | 'md';
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  open,
  title,
  subtitle,
  message,
  children,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  onConfirm,
  onCancel,
  severity = 'warning',
  submitDisabled,
  submitLoading,
  dataTestId = 'confirmation-modal',
  maxWidth = 'sm',
}) => {
  const getIconColor = () => {
    switch (severity) {
      case 'error':
        return 'error.main';
      case 'warning':
        return 'warning.main';
      case 'info':
        return 'info.main';
      default:
        return 'warning.main';
    }
  };

  return (
    <BaseModal
      dataTestId={dataTestId}
      open={open}
      onClose={onCancel}
      onSubmit={onConfirm}
      title={title}
      subtitle={subtitle}
      icon={<WarningIcon sx={{ color: getIconColor() }} />}
      submitText={confirmText}
      cancelText={cancelText}
      submitDisabled={submitDisabled}
      submitLoading={submitLoading}
      maxWidth={maxWidth}
    >
      {typeof message === 'string' ? (
        <Typography>{message}</Typography>
      ) : (
        message
      )}
      {children}
    </BaseModal>
  );
};

export default ConfirmationModal;
